module.exports = "https://trybtryb-legacy.web.app/img/square-transparent-mobile.3cb0e878.svg";